import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButtonMedium as TextButton } from '@xingternal/malt-button';
import Image from '@xingternal/malt-image';

import FileUploadImage from './../../../Components/Illustrations/FileUploadImage';
import FileUploadHowToModal from './FileUploadHowToModal';

import styles from './FileUpload.css';

const renderImagePreview = (imageUrl, messages) => {
  if (imageUrl) {
    return (
      <>
        <div className={styles.centerItem}>
          <Image src={imageUrl} />
        </div>

        <TextButton noPadding className={styles.centerItem}>
          <FormattedMessage {...messages.fileUploadChangeLabel} />
        </TextButton>
      </>
    );
  } else {
    return (
      <>
        <FileUploadImage />

        <TextButton noPadding className={styles.centerItem}>
          <FormattedMessage {...messages.fileUploadAddLabel} />
          <br />
          <FormattedMessage {...messages.fileUploadMaxSize} />
        </TextButton>
      </>
    );
  }
};

const maxFileSize = 5 * 1000000; // 5mb
const acceptFileTypes = 'image/png, image/jpeg, image/bmp';

const FileUpload = ({ onChange, name, messages, value }) => {
  const maybeImagePreview = value && URL.createObjectURL(value);

  const [imagePreview, setImagePreview] = useState(maybeImagePreview);
  const fileInputRef = useRef(null);

  const handleFileUploadChange = e => {
    const uploadedImage = e.currentTarget.files[0];

    if (uploadedImage.size > maxFileSize) {
      fileInputRef.current.value = null;
      setImagePreview(null);
      onChange(null, 'FILE_SIZE_EXCEEDED');
      return;
    }

    if (
      !['image/png', 'image/jpeg', 'image/bmp'].includes(uploadedImage.type)
    ) {
      fileInputRef.current.value = null;
      setImagePreview(null);
      onChange(null, 'FILE_TYPE_NOT_ACCEPTED');
      return;
    }

    setImagePreview(URL.createObjectURL(uploadedImage));
    onChange(uploadedImage);
  };

  const openFileUpload = () => fileInputRef.current.click();

  return (
    <>
      <div className={styles.label} onClick={openFileUpload}>
        {renderImagePreview(imagePreview, messages)}
      </div>

      <div className={styles.divider} />

      <FileUploadHowToModal />

      <input
        onChange={handleFileUploadChange}
        className={styles.invisible}
        accept={acceptFileTypes}
        ref={fileInputRef}
        type={'file'}
        name={name}
      />
    </>
  );
};

export default FileUpload;
